<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Edycja współczynnika grupy produktowej - <strong>{{ productGroupFactor.name }}, {{ productGroupFactor.type.name }}</strong>
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="productGroupFactor.value"
                            label="Wartość narzutu"
                            type="number"
                            suffix="%"
                            :error-messages="valueErrors"
                            outlined
                            dense
                            required
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :loading="actionLoading"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { required, integer } from 'vuelidate/lib/validators'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'ProductGroupFactorDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        productGroupFactorData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            productGroupFactor: {
                name: null,
                value: null,
                type: {
                    name: null
                }
            },
            actionLoading: false,
        }
    },
    validations: {
        productGroupFactor: {
            value: {
                required,
                integer
            }
        }
    },
    computed: {
        // Walidacje
        valueErrors() {
            const errors = []

            if (!this.$v.productGroupFactor.value.$dirty) return errors
            !this.$v.productGroupFactor.value.required && errors.push('Proszę podać wartość współczynnika.')
            !this.$v.productGroupFactor.value.integer && errors.push('Proszę podać liczbę całkowitą.')

            return errors
        },
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.productGroupFactor = JSON.parse(JSON.stringify(this.productGroupFactorData))
            }
        },
    },
    methods: {
        onSave() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })

                return
            }

            this.actionLoading = true

            this.$store.dispatch('configurations/calculationsCosts/updateProductGroupFactor', this.productGroupFactor)
                .then(() => {
                    this.$emit('on-confirm')
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading = false
                    this.onClose()
                })
        },
        onClose() {
            setTimeout(() => {
                this.productGroupFactor = {
                    name: null,
                    type: {
                        name: null
                    },
                    value: null
                }
                this.$v.$reset()
            }, 500)

            this.$emit('on-close')
        }
    }
}
</script>

